module.exports = __webpack_public_path__ + "img/blank-comic-book_B0991LHXYV.34a48e3d.jpg";